import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useLazyGetBoostPlansByIdQuery } from "../../service/boostPlans";
import Loader from "../../constants/Loader";
import { showError } from "../../constants/toasts";
import moment from "moment";

const BoostPlanDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [getBoostPlanById, { isLoading }] = useLazyGetBoostPlansByIdQuery();
  const [plan, setPlan] = useState<any | null>(null);

  const fetchDetails = async () => {
    if (!id) {
      showError("Invalid boost plan id");
      navigate("/manage-boost-plans");
      return;
    }
    try {
      const res = await getBoostPlanById(id as any).unwrap();
      if (res?.code === 200) {
        setPlan(res?.data || null);
      } else {
        showError(res?.message || "Failed to fetch boost plan details");
        navigate("/manage-boost-plans");
      }
    } catch (e: any) {
      showError(e?.data?.message || "Failed to fetch boost plan details");
      navigate("/manage-boost-plans");
    }
  };

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="main_title">
        <h1>Boost Plans Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-boost-plans")}>
            Manage Boost Plans
          </button>{" "}
          - Boost Plans Detail
        </p>
      </div>
      <Loader isLoad={isLoading} />

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Title</h6>
            <p>{plan?.title || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Price</h6>
            <p>{plan?.price ?? "-"} GH₵</p>
          </div>
          <div className="w_33">
            <h6>Duration(Days)</h6>
            <p>{plan?.duration ?? "-"}</p>
          </div>
          <div className="w_33">
            <h6>Assign to Category</h6>
            <p>{plan?.category?.name || plan?.category || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {plan?.createdAt ? moment(plan?.createdAt).format("lll") : "-"}
            </p>
          </div>
          <div className="w_33">
            <h6>Status</h6>
            <p>{!plan?.isBlocked ? "Active" : "In-Active"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoostPlanDetail;
